import React, { Component } from 'react'
import { connect } from 'react-redux'
import { accountAccessShowLogin } from 'actions/UiActions'
import { selectLoggedIn } from 'selectors/accountSelectors'

import TextButton from '../../../../LuxKit/Button/TextButton'

interface Props {
  isLoggedIn: boolean
  buttonText?: string
  buttonClass?: string
  buttonProps?: Partial<React.ComponentProps<typeof TextButton>>
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  accountAccessShowLogin: () => void
  children: React.ReactNode
}

interface State {
  awaitingLogin: boolean
}

class LoggedInOnly extends Component<React.PropsWithChildren<Props>, State> {
  state = {
    awaitingLogin: false,
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.isLoggedIn && !prevProps.isLoggedIn && this.state.awaitingLogin) {
      this.setState({
        awaitingLogin: false,
      })
    }
  }

  showLogin: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      awaitingLogin: true,
    })
    this.props.accountAccessShowLogin()
  }

  render() {
    const { buttonText, buttonClass, buttonProps, children, isLoggedIn } = this.props
    if (isLoggedIn) {
      return (
        <>{children}</>
      )
    }
    if (buttonText) {
      return (
        <TextButton
          kind="primary"
          {...buttonProps}
          className={buttonClass}
          onClick={this.showLogin}
          data-testid="login-to-see"
        >
          {buttonText}
        </TextButton>
      )
    }
    return null
  }
}

const mapStateToProps = (state: App.State) => ({
  isLoggedIn: selectLoggedIn(state),
})

const mapDispatchToProps = {
  accountAccessShowLogin,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInOnly)
